export default __webpack_public_path__ + "static/media/img-white-paper-new.d742dbde.png";